module.exports = __webpack_public_path__ + "img/logo-all.4d609e07.png";